var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardHeader',[_vm._v("Reservas nos últimos 6 meses")]),_c('CCardBody',[(_vm.chartData)?_c('CChartLine',{staticStyle:{"height":"300px"},attrs:{"datasets":[
  {
    data: _vm.chartData.map(function (item) {return item.total}),
    backgroundColor: '#5373E5',
    label: 'Reservas',
  }
],"labels":_vm.chartData.map(function (item) {return item.month}),"options":{
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                stepSize: 1
                            }
                        }]
                    }
                }}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }